// extracted by mini-css-extract-plugin
export default {"box":"PreOrderCodeInput_box__M3ie2","span":"PreOrderCodeInput_span__irsec","input":"PreOrderCodeInput_input__77g7r"};